import React, { useEffect, useState } from 'react';
import serviceApi from '../../../services/serviceApi';
import environment from '../../../environments/environment';

type BackendRemark = {
  type?: string;
  dateTime?: string;
  date?: string;
  message?: string;
  remarks?: string;
  attachmentUrl?: string;
  teacher?: string;
  subject?: string;
  title?: string;
  by?: string;
};

type RemarksResponse = {
  status: string;
  message: string;
  hasMore?: boolean;
  dataList?: BackendRemark[];
};

const normalizeTitle = (r: BackendRemark) => {
  return (
    r.by ||
    r.title ||
    r.subject ||
    r.type ||
    r.teacher ||
    'Remark'
  );
};

const RemarksComponent: React.FC = () => {
  const [remarks, setRemarks] = useState<BackendRemark[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
      console.log("Remarks component mounted");
    fetchRemarks();
  }, []);

  const fetchRemarks = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const resp = await serviceApi.get<RemarksResponse>(
        environment.remarks
      );

      let list: BackendRemark[] = [];
      if (resp.status === 'SUCCESS') {
        list = Array.isArray(resp.dataList) ? resp.dataList : [];
      } else {
        setError(resp.message || 'Failed to fetch remarks');
      }

      setRemarks(list);
    } catch (err: any) {
      console.error(
        'Remarks API Error:',
        err?.response?.data || err.message
      );
      setError('An error occurred while fetching remarks');
      setRemarks([]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="remarks-page">
      <h2 className="title-text" style={{ textAlign: 'center' }}>
        Remarks
      </h2>

      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-overlay__content">
            <div className="spinner spinner--lg"></div>
            <span className="loading-text">Loading remarks...</span>
          </div>
        </div>
      )}

      {error && <p className="error-text">{error}</p>}

      {!isLoading && !error && remarks.length > 0 &&
        remarks.map((r, idx) => (
          <div key={idx} className="event-container">
            <h3 className="title-text">{normalizeTitle(r)}</h3>

            {(r.message || r.remarks) && (
              <p className="event-description">
                {r.message || r.remarks}
              </p>
            )}

            {(r.dateTime || r.date) && (
              <span className="event-date">
                {r.dateTime || r.date}
              </span>
            )}
          </div>
        ))}

      {!isLoading && !error && remarks.length === 0 && (
        <p className="no-events">No remarks available</p>
      )}
    </div>
  );
};

export default RemarksComponent;